import { Controller } from "@hotwired/stimulus"

// A segmented pill that swaps panels on one page (the event's Lineup and
// Results). Each tab and each panel carries data-panel with the same name.
// Without JavaScript nothing is hidden and both panels simply follow each
// other down the page, which is how the page read before.
export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    const first = this.tabTargets[0]
    if (first) this.show(first.dataset.panel)
  }

  select(event) {
    this.show(event.currentTarget.dataset.panel)
  }

  show(name) {
    this.tabTargets.forEach((tab) => {
      const on = tab.dataset.panel === name
      tab.classList.toggle("on", on)
      tab.setAttribute("aria-pressed", String(on))
    })
    this.panelTargets.forEach((panel) => { panel.hidden = panel.dataset.panel !== name })
  }
}
